import { useQuery } from "@tanstack/react-query";
import {
  FormAssignmentConfigDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_QUESTIONS_ASSIGNMENT } from "../domain";

import { questionsAssignmentApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_FORM_ASSIGNMENT_CONFIG = "GET_FORM_ASSIGNMENT_CONFIG";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

interface GetFormAssignmentConfigRequest {
  formId?: string;
}

const getFormAssignmentConfig = async (
  params: GetFormAssignmentConfigRequest,
): Promise<FormAssignmentConfigDto> => {
  const { formId = "" } = params;

  const response =
    await questionsAssignmentApi.assignmentsConfigControllerGetFormAssignmentConfig(
      formId,
    );

  return response.data;
};

export const useGetFormAssignmentConfig = (
  user: UserProfileDto | null,
  params: GetFormAssignmentConfigRequest,
): {
  formAssignmentConfig?: FormAssignmentConfigDto;
  formAssignmentConfigEnabled: boolean;
  isPendingGetFormAssignmentConfig: boolean;
  isLoadingGetFormAssignmentConfig: boolean;
  isSuccessGetFormAssignmentConfig: boolean;
  isFetchingGetFormAssignmentConfig: boolean;
} => {
  const enabled = !!params?.formId && roleGuard(user, allowedRoles);
  const { isPending, data, isLoading, isSuccess, isFetching } = useQuery({
    queryKey: [
      DOMAIN_QUESTIONS_ASSIGNMENT,
      ACTION_GET_FORM_ASSIGNMENT_CONFIG,
      params,
    ],
    queryFn: () => getFormAssignmentConfig(params),
    enabled,
    staleTime: TANSTACK_QUERY_STALE_TIME,
  });

  return {
    formAssignmentConfig: data,
    formAssignmentConfigEnabled: enabled,
    isPendingGetFormAssignmentConfig: isPending,
    isLoadingGetFormAssignmentConfig: isLoading,
    isSuccessGetFormAssignmentConfig: isSuccess,
    isFetchingGetFormAssignmentConfig: isFetching,
  };
};
